<div class="condition-container" [ngClass]="{'show': open, 'hide':!open}">
  <div class="condition-group">
    <p class="condition-header" *ngIf="showHeader">
      <ng-content select=".name"></ng-content>
    </p>
    <div class="condition-body">
      <ng-content select=".edit-field"></ng-content>
    </div>
  </div>
</div>